<template>
  <div class="safe-index-container">
      <div class="title">
        <div class="label">欢迎您:</div>
        <div class="text-content">
          <span v-if="!isEditing" class="normal-text" @click="editHandler">{{userInfo && userInfo.nickName}}</span>
          <a-input
            ref="editInput"
            v-model="editValue"
            v-if="isEditing"
            class="edit-input"
            size="small"
            @blur="blurHandler"/>
        </div>
      </div>
      <div class="warp-items">
        <div class="item">
          <img class="icon" src="@assets/images/icon-changePassword.png" alt="...">
          <div class="title-name">登录密码</div>
          <div class="inner">请定期更新您的密码，以保护账号安全</div>
          <div class="action">
            <span @click="jumpTolink('safe-change-password')">修改</span>
          </div>
        </div>
        <div class="item">
          <img class="icon" src="@assets/images/icon-bindPhone.png" alt="...">
          <div class="title-name">绑定手机</div>
          <div class="inner">您的绑定手机：{{userInfo && userInfo.phone | hidePhone}}</div>
          <div class="action">
            <span @click="jumpTolink('safe-change-phone')">修改</span>
          </div>
        </div>
        <div class="item">
          <img class="icon" src="@assets/images/icon-bindEmail.png" alt="...">
          <div class="title-name">绑定邮箱</div>
          <div class="inner">您的绑定邮箱：{{userInfo && userInfo.email | hideEmail}}</div>
          <div class="action">
            <span @click="jumpTolink('safe-change-email')">修改</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { Button, Input } from 'ant-design-vue';
  import { $http, util } from '@utils'
  import host from '@utils/api'
  import queryString from 'query-string'
  import vuexMapper from '@mixins'
  import filters from '../filters'
  import ModifyNoicNameParam from "../classes/modifyNoicNameParam";
  export default {
    name: "safe",
    components: {
      Button,
      [Input.name]: Input
    },
    mixins: [filters, vuexMapper],
    mounted () {
      util.$tracker(157, '288923',10000);
      this.getUserInfo2Interceptor()
    },
    data () {
      return {
        isEditing: false,
        editValue: ''
      }
    },
    watch: {
      userInfo (v) {
        if (v.nickName) {
          this.editValue = v.nickName
        }
      }
    },
    methods: {
      jumpTolink (name) {
        this.$router.push({
          name
        })
      },
      editHandler () {
        this.isEditing = true
        this.$nextTick(() => {
          this.$refs.editInput.focus()
        })

      },
      async blurHandler () {
        const { code, msg } = await this.modifyNickname(this.editValue)
        if (code * 1 === 1) {
          this.$message.success('修改成功！')
          this.isEditing = false
          this.getUserInfo2Interceptor()
        } else {
          if (code * 1 !== 3) {
            this.$message.error(msg)
          }
        }
      },
      async modifyNickname (nickName) {
        const { userInfo } = this
        const param = JSON.stringify(new ModifyNoicNameParam(userInfo.id, userInfo.phone, nickName))
        return $http.post(`${host.mainHost}${host.mainContentPath}/account/modifyNickname.do`, queryString.stringify({ param }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.safe-index-container {
  padding: 80px 200px;
  > .title {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    display: flex;
    > .label {
      width: 60px;
      word-break: keep-all;
    }
    > .text-content {
      flex: 1;
      .normal-text {
        border: 1px solid transparent;
        display: inline-block;
        // width: 120px;
        &:hover {
          cursor: pointer;
          border-color: #f5f5f5;
        }
      }
      .edit-input {
        width: 120px;
      }
    }
  }
  .warp-items {
    .item {
      display: flex;
      align-items: center;
      margin-top: 30px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      .icon {
        display: block;
        width: 60px;
        height: 60px;
      }
      .title-name {
        width: 100px;
        padding: 0 15px;
      }
      .inner {
        flex: 1;
        padding-left: 80px;
      }
      .action {
        width: 50px;
        color: #116CD0;
        text-decoration: underline;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
